module.exports = __webpack_public_path__ + "static/media/about_pic_mess01.cc92d16a.jpg";